import { useEffect } from 'react';

const UnAccessible = () => {
  useEffect(() => {
    // 为了相应主 App 路径
    window.location.href = '/exception/403';
  }, []);

  return <div>UnAccessable</div>;
};

export default UnAccessible;
